module.exports = __webpack_public_path__ + "static/media/59.7f23849c.png";